<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="`Edit User: ${user.FirstName} ${user.LastName} [Reseller Accounts] :: MeritEHS`" v-if="UserId" />
            <vue-headful :title="`New User [Reseller Accounts] :: MeritEHS`" v-else />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/resellers/accounts`">
                            <i class="fa fa-sitemap"></i> Reseller Accounts
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/resellers/accounts/view/${account.SmartBizClientId}`">
                            {{ account.ClientName }}
                        </router-link>
                    </li>
                    <template v-if="UserId">
                        <li class="breadcrumb-item active">
                            Edit {{ user.FirstName }} {{ user.LastName }}
                        </li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active">
                            New User
                        </li>
                    </template>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8">
                    <form class="card mb-4" autocomplete="off">
                        <div class="card-header">User Details</div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Account:</label>
                                <div class="col-sm-8 pt-2">
                                    {{ account.ClientName }}
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.FirstName}">
                                    First Name: <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">

                                    <b-form-input type="text" v-model="user.FirstName" :class="{'is-invalid': errors.FirstName}" placeholder="Enter First Name"></b-form-input>

                                    <span v-if="errors.FirstName" class="text-danger">
                                        <span v-for="error in errors.FirstName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.LastName}">
                                    Last Name: <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">

                                    <b-form-input type="text" v-model="user.LastName" :class="{'is-invalid': errors.LastName}" placeholder="Enter Last Name"></b-form-input>

                                    <span v-if="errors.LastName" class="text-danger">
                                        <span v-for="error in errors.LastName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.email}">
                                    Email: <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">

                                    <b-form-input type="email" v-model="user.email" :class="{'is-invalid': errors.email}" placeholder="Enter Email Address"></b-form-input>

                                    <span v-if="errors.email" class="text-danger">
                                        <span v-for="error in errors.email">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.timezone_slug}">
                                    Timezone <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">
                                    <select v-model="user.timezone_slug" :class="{'form-control': true, 'is-invalid': errors.timezone_slug}">
                                        <option :value="undefined">-- Select a Timezone --</option>
                                        <option v-for="timezone in timezones" :value="timezone.zone_slug">
                                            {{ timezone.display_name }}
                                        </option>
                                    </select>
                                    <span v-if="errors.timezone_slug" class="text-danger">
                                        <span v-for="error in errors.timezone_slug">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group" v-if="false">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.EmployeeId}">Employee Record:</label>
                                <div class="col-sm-8">

                                    <employee-select ref="userEmployee" :selectedValues="userEmployee" @vselected="setUserEmployee" :filters="{'SmartBizClientId': user.SmartBizClientId}" :hasError="errors.EmployeeId ? true : false"></employee-select>

                                    <div v-if="errors.EmployeeId" class="text-danger">
                                        <span v-for="error in errors.EmployeeId">{{ error }}</span>
                                    </div>
                                    <div v-if="errors.existing_employee" class="text-danger">
                                        A user with this employee already exists. Click <router-link :to="`/users/view/${errors.existing_employee}`">here</router-link> to view the other user.
                                    </div>
                                </div>
                            </div>
                            <hr/>

                            <template v-if="false">
                                <div class="form-group row">
                                    <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.password}">Password:</label>
                                    <div class="col-sm-8">

                                        <input type="password" v-model="user.password" placeholder="Minimum 8 Characters" :class="{'form-control': true, 'is-invalid': errors.password}" autocomplete="new-password" />

                                        <span v-if="errors.password" class="text-danger">
                                            <span v-for="error in errors.password">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.password_confirmation}">Confirm Password:</label>
                                    <div class="col-sm-8">

                                        <input type="password" v-model="user.password_confirmation" placeholder="Confirm your password" :class="{'form-control': true, 'is-invalid': errors.password_confirmation}" autocomplete="new-password" />

                                        <span v-if="errors.password_confirmation" class="text-danger">
                                            <span v-for="error in errors.password_confirmation">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <hr />
                            </template>

                            <div class="row form-group">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.IsActive}">Active:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="user.IsActive" class="mt-2" :value="1" :unchecked-value="0" plain></b-form-checkbox>

                                    <span v-if="errors.IsActive" class="text-danger">
                                        <span v-for="error in errors.IsActive">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.sendEmailInvite}">Email User:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="user.sendEmailInvite" class="mt-2" :value="true" :unchecked-value="false" plain>
                                        Send New User Invite to {{ user.FirstName }}
                                    </b-form-checkbox>

                                    <span v-if="errors.sendEmailInvite" class="text-danger">
                                        <span v-for="error in errors.sendEmailInvite">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg-4" v-if="roles.length > 0">
                    <div class="card mb-3">
                        <div class="card-header"><strong><i class="fa fa-lock"></i> Roles</strong></div>
                        <div class="card-body">
                            <b-form-checkbox-group v-model="selectedRoles" plain>
                                <div v-for="role in roles">
                                    <b-form-checkbox :value="role.id">{{ role.name }}</b-form-checkbox>
                                </div>
                            </b-form-checkbox-group>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="saveUser()" :disabled="saving">
                <template v-if="user.UserId">Update</template>
                <template v-else>Create</template>
                User
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                account_id: this.$route.params.id,
                UserId: this.$route.params.UserId,
                query: this.$route.query,
                user: {},
                account: {},
                errors: {},
                timezones: {},
                selectedRoles: [],
                roles: [],
            }
        },

        computed: {
            userEmployee(){
                //check for null
                if(!this.user.EmployeeId)
                {
                    return {};
                }

                //Return the values
                return {EmployeeId: this.user.EmployeeId, FirstName: this.user.EmployeeFirstName, LastName: this.user.EmployeeLastName, EmployeeNumber: this.user.EmployeeNumber};
            }
        },


        methods: {

            getUser() {
                //Get the data
                this.$http
                    .get('resellers/accounts/users/'+this.account_id + (this.UserId ? '/' + this.UserId : ''), this.query)
                    .then(response => {
                        //Set all the data
                        this.account = response.data.account;
                        this.user = response.data.user;
                        this.timezones = response.data.timezones;
                        //this.roles = response.data.roles;
                        //this.selectedRoles = response.data.selectedRoles;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveUser() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Build the payload
                //let payload = {...this.account, ...this.user};
                //Set the users roles
                this.user.roles = this.selectedRoles;

                //Set the payload
                let payload = this.user;

                //Send it
                this.$http
                .post('resellers/accounts/users/'+this.account_id, payload)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('User Saved');

                    //Return to main list?
                    this.$router.push('/resellers/accounts/view/' + this.account_id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            setUserEmployee(employee){
                //Check for null
                if(!employee)
                {
                    this.user.EmployeeId = null;
                    return;
                }

                //Else
                this.user.EmployeeId = employee.EmployeeId;
            },
        },

        mounted() {
            //Get the incidents
            this.getUser();
        }
    }
</script>
